import { useSession } from '@airship-platform/airship-auth';
import { FlexBox } from '@airship-platform/jam-web/components';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router';
import { ROUTE_PATHS } from '../App.routes';
import SignInForm from './SignInForm';

const SignInPage: React.FC = () => {
  const [params] = useSearchParams();
  const { isAuthenticating, error, signIn, buildCallbackUrl, refreshSession } =
    useSession();

  useEffect(() => {
    const callbackUrl = params.get('callbackUrl');
    const navigateUrl = new URL(
      (callbackUrl && new URL(callbackUrl).searchParams.get('returnUrl')) ||
        window.location.origin
    );

    refreshSession().then(
      (tokens) =>
        window.location.origin === navigateUrl.origin &&
        !!tokens?.idToken &&
        window.location.replace(navigateUrl.href)
    );
  }, [refreshSession, params]);

  const signInAndRedirect = (email: string, password: string) =>
    signIn(email, password).then(
      (tokens) =>
        tokens &&
        window.location.replace(
          buildCallbackUrl(tokens, params.get('callbackUrl'))
        )
    );

  return (
    <FlexBox
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      alignSelf={'center'}
      height={'100vh'}
    >
      <SignInForm
        signIn={signInAndRedirect}
        isLoading={isAuthenticating}
        errorMessage={error}
      >
        <Typography variant="body2">
          Forgot your password?{' '}
          <Link
            component={RouterLink}
            to={ROUTE_PATHS.FORGOT_PASSWORD}
            variant="body2"
          >
            Reset password
          </Link>
        </Typography>
      </SignInForm>
    </FlexBox>
  );
};

export default SignInPage;
